import {api} from '../api'
import {documentTempToID} from '../bid/bidSagas'
import {
  filterSellersByLegalType,
  LEGAL_TYPE_FL,
  withDefaultSellerLegalType,
} from 'src/utils/sellerRecipientChip'

export const selectedDocumentStatus = {}
export const sellerDocumentMappingId = {}
export const sellerDocumentTempToID = (tempId) => {
  return sellerDocumentMappingId[tempId] ? sellerDocumentMappingId[tempId] : tempId
}

export const sellerApi = api.injectEndpoints({
  endpoints: (build) => ({
    search: build.query({
      query(params) {
        return {
          url: `/seller/search/`,
          method: 'GET',
          params: {
            legal_type: LEGAL_TYPE_FL,
            ...params,
          },
        }
      },
      transformResponse(response, _meta, params) {
        return filterSellersByLegalType(response, params?.legal_type || LEGAL_TYPE_FL)
      },
    }),

    fetchSellers: build.query({
      query(params) {
        return {
          url: `/seller/`,
          method: 'GET',
          params: {
            // sellerperson__is_active: false,
            ...params,
          },
        }
      },
    }),

    smartSearch: build.query({
      query(params) {
        return {
          url: `/seller/smart_search/`,
          method: 'GET',
          params: {
            // is_active: false,
            ...params,
          },
        }
      },
    }),


    getPost: build.query({
      query: (id) => {
        return {
          url: '/bid/',
          method: 'GET',
          params: {
            page: 1,
            endpoint_id: '018a283e-6b2e-08ce-133b-59c4627c0633',
          }
        }
      },
      // providesTags: (_result, _err, id) => [{type: 'Posts', id}],
    }),

    fetchSellerId: build.query({
      query(payload) {
        return {
          url: `/seller/${payload.id}/`,
          method: 'GET',
        }
      },
    }),
    sendSellerOnboardingLink: build.query({
      query({id}) {
        return {url: `/seller/${id}/send_onboarding_link/`, method: 'POST', data: {}}
      },
    }),
    updateSeller: build.query({
      query(payload) {

        const sellerData = payload.sellerData
        const merchant_id = payload.merchant_id
        return {
          url: `/seller/${sellerData.id}/`,
          method: 'PUT',
          data: {
            ...sellerData,
            ...(sellerData.legal_type === 'semp' && payload.file_document_ids !== undefined
              ? {file_document_ids: payload.file_document_ids}
              : {}),
            gender: undefined,
            // inn: undefined,
            place_of_birth: sellerData.legal_type === 'semp' ? sellerData.place_of_birth : undefined,
            merchant_id,
          },
        }
      },
    }),
    createSeller: build.query({
      query(payload) {
        const sellerData = withDefaultSellerLegalType(payload.sellerData)
        const merchant_id = payload.merchant_id

        return {
          url: `/seller/`,
          method: 'POST',
          showError: payload.showError !== false,
          data: {
            ...sellerData,
            file_document_ids: payload.file_document_ids,
            gender: undefined,
            // inn: undefined,
            place_of_birth: sellerData.legal_type === 'semp' ? sellerData.place_of_birth : undefined,
            merchant_id,
          },
        }
      },
    }),

    sellerBidDocumentRecognise: build.query({
      query(payload) {
        const {file} = payload
        const id = documentTempToID(file.tempId)

        return {
          url: `/bid-file-document/${id}/recognise/`,
          method: 'GET',
        }
      },
    }),
    sellerDocumentRecognise: build.query({
      query(payload) {
        const {file} = payload
        const id = sellerDocumentTempToID(file.tempId)

        return {
          url: `/file-document/${id}/recognize_person_passport/`,
          method: 'GET',
        }
      },
    }),

    fetchSellerRequisite: build.query({
      query(params) {
        return {
          url: `/seller-requisite/`,
          method: 'GET',
          showError: false,
          params: {
            ...params,
          },
        }
      },
    }),

    createSellerRequisite: build.query({
      query(payload) {
        return {
          url: `/seller-requisite/`,
          method: 'POST',
          data: payload
        }
      },
    }),

    updateSellerRequisite: build.query({
      query(payload) {
        return {
          url: `/seller-requisite/${payload?.id}/`,
          method: 'PUT',
          data: payload
        }
      },
    }),

    deleteSellerRequisite: build.query({
      query(payload) {
        return {
          url: `/seller-requisite/${payload.id}/`,
          method: 'DELETE',
          data: payload
        }
      },
    }),


    createSellerDocument: build.query({
      query(payload) {

        const formData = new FormData()

        const dictionary = payload.dictionary

        // formData.append("bid_id", payload.bid.id);
        formData.append("file_document_type_id", dictionary.fileDocuments[payload.type].id);
        formData.append("file", payload.file);
        return {
          url: `/file-document/`,
          method: 'POST',
          data: formData,
          headers: {"Content-Type": "multipart/form-data"},
        }
      },
    }),


    createSellerImport: build.query({
      query(payload) {
        const formData = new FormData()
        formData.append("import_type", payload.importType)
        formData.append("merchant_id", payload.merchant_id)
        formData.append("file", payload.file)

        return {
          url: `/seller/import_seller/`,
          method: 'POST',
          headers: {
            'Content-Type': 'multipart/form-data;'
          },
          data: formData,
        }
      },
    }),

    fetchSellerRegistries: build.query({
      query({page, page_size, endpoint_id, document_number__exact}) {
        return {
          url: '/seller-registry/',
          method: 'GET',
          params: {
            page,
            page_size,
            endpoint_id,
            ...(document_number__exact ? {document_number__exact} : {}),
          },
        }
      },
    }),
    fetchSellerRegistryById: build.query({
      query({id}) {
        return {url: `/seller-registry/${id}/`, method: 'GET'}
      },
    }),
    fetchSellerRegistrySellers: build.query({
      query({id, page, page_size}) {
        return {
          url: `/seller-registry/${id}/get_sellers/`,
          method: 'GET',
          params: {page, page_size},
        }
      },
    }),
    uploadSellerRegistry: build.query({
      query({endpoint_id, file}) {
        const data = new FormData()
        if (endpoint_id != null) data.append('endpoint_id', endpoint_id)
        data.append('file', file)
        return {
          url: '/seller-registry/',
          method: 'POST',
          data,
          headers: {'Content-Type': undefined},
        }
      },
    }),
    confirmSellerRegistryLoad: build.query({
      query({id}) {
        const data = new FormData()
        data.append('load_allowed', 'true')
        return {
          url: `/seller-registry/${id}/`,
          method: 'PUT',
          data,
          headers: {'Content-Type': undefined},
        }
      },
    }),

    deleteSellerDocument: build.query({
      query(payload) {
        let id = payload?.file?.tempId ?? payload?.file
        if (id && sellerDocumentMappingId[id]) {
          id = sellerDocumentMappingId[id]
        }
        return {
          url: `/file-document/${id}/`,
          method: 'DELETE',
        }
      },
    }),



    // updatePost: build.mutation({
    //   query(data) {
    //     const {id, ...body} = data
    //     return {
    //       url: `posts/${id}`,
    //       method: 'PUT',
    //       body,
    //     }
    //   },
    //   invalidatesTags: (post) => [{type: 'Posts', id: post?.id}],
    // }),
    // deletePost: build.mutation({
    //   query(id) {
    //     return {
    //       url: `posts/${id}`,
    //       method: 'DELETE',
    //     }
    //   },
    //   invalidatesTags: (post) => [{type: 'Posts', id: post?.id}],
    // }),
  }),
})
